import React, { Component } from 'react';
import Dropdown from './Dropdown';
import qs from 'qs';
import PropTypes from 'prop-types';

export default class PushParamDropdown extends Component {
  static propTypes = {
    defaultOption: PropTypes.string.isRequired,
    selectedOption: PropTypes.string,
    displayPrefix: PropTypes.string,
    options: PropTypes.object,
    items: PropTypes.array,
    queryName: PropTypes.string.isRequired,
    triggerClass: PropTypes.string,
    wrapperClass: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = { selected: this.props.selectedOption || this.props.defaultOption };
  }

  handleClick = (option) => {
    const output = {};
    output[this.props.queryName] = option.key;
    const params = Object.assign(qs.parse(window.location.search.slice(1)), output);
    if (option.key === this.props.defaultOption) delete params[this.props.queryName];

    const search = qs.stringify(params, { arrayFormat: 'brackets' });
    router.push({ pathname: location.pathname, search });

    this.setState({ selected: option.key });
  }

  render() {
    return (
      <Dropdown
        className={this.props.wrapperClass}
        contentClassName="dropdown-card"
        listClassName="u-text-old-primary-color-blue u-text-sm"
        triggerClassName={`Button Button--withCaret u-text-lg md:u-text-sm u-py-2 u-pl-2 u-leading-normal md:u-leading-tight u-text-old-primary-color u-float-right u-m-0 ${this.props.triggerClass}`}
        currentItemText={this.props.options[this.state.selected]}
        addMarginTop={false}
        name={this.props.displayPrefix}
        active={true}
        asyncCallback={this.handleClick}
        items={this.props.items}
      />
    );
  }
}
